const routes = {
  login: {
    root: "/login",
  },
  homePage: {
    homePage: "/homePage",
  },
  packageDetails: {
    packageDetails: "/packageDetails",
  },
  createPackage: {
    createPackage: "/createPackage",
  },
  createProductOfferings: {
    createProductOfferings: "/createProductOfferings",
  },
  createPackageVersion: {
    createPackageVersion: "/createPackageVersion",
  },
  uploadFeatureOfferings: {
    uploadFeatureOfferings: "/uploadFeatureOfferings",
  },
  uploadPackageSchedule: {
    uploadPackageSchedule: "/uploadPackageSchedule",
  },
  updatePackageSchedule: {
    updatePackageSchedule: "/updatePackageSchedule",
  },
  uploadOrUpdatePackagePaymentHead: {
    uploadOrUpdatePackagePaymentHead: "/uploadOrUpdatePackagePaymentHead"
  }
};

export default routes;
